// extracted by mini-css-extract-plugin
export default {"tooltip":"header-tooltip_tooltip__SPERQ"};